import clsx from 'clsx';

const VIEWBOX = 40;
const RADIUS = 16;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

interface Props {
  /** How much of the ring is filled, from 0 to 1. Values outside are clamped. */
  ratio: number;
  /**
   * Colours the filled arc, which is drawn in currentColor. Pass a text colour
   * so the caller decides what a given fill level means.
   */
  className?: string;
  'aria-label'?: string;
}

/**
 * A ring filled clockwise in proportion to a ratio, for showing how full
 * something is at a glance.
 */
export function Gauge({ ratio, className, 'aria-label': ariaLabel }: Props) {
  const filled = Math.min(Math.max(ratio, 0), 1);

  return (
    <svg
      viewBox={`0 0 ${VIEWBOX} ${VIEWBOX}`}
      className={clsx('h-10 w-10', className)}
      role="img"
      aria-label={ariaLabel}
    >
      <circle
        cx={VIEWBOX / 2}
        cy={VIEWBOX / 2}
        r={RADIUS}
        fill="none"
        strokeWidth="4"
        className="stroke-gray-4 th-highcontrast:stroke-gray-8 th-dark:stroke-gray-8"
      />
      <circle
        cx={VIEWBOX / 2}
        cy={VIEWBOX / 2}
        r={RADIUS}
        fill="none"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeDasharray={`${CIRCUMFERENCE * filled} ${CIRCUMFERENCE}`}
        transform={`rotate(-90 ${VIEWBOX / 2} ${VIEWBOX / 2})`}
      />
    </svg>
  );
}
